import React, { FC, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import DSOpStatusSecuence from '../../../Services/Operaciones/OpViajes.Services'
import { deleteOpViajes, updateOpViajes } from '../../../store/features/Operaciones/OpViajesSlice'
import DTOChangeTripStatus from '../../../DTOs/Operaciones/DTOChangeTripStatus'
import DTOOpViajes from '../../../DTOs/Operaciones/DTOViajes'
import DTOViajes from '../../../DTOs/Operaciones/DTOViajes'
import DTOViajeEstatusSecuencia from '../../../DTOs/Operaciones/DTOViajeEstatusSecuencia'
import { setStatus } from '../../../store/features/Auth/UserProfileSlice'
import { SignatureHelpTriggerReason } from 'typescript'

interface IProps {
  IDViaje: number
  sCliente: string
  TipoOperacion: number
  Status: number
}

export const ViajeEstatus: FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const mTripStatus = useSelector((state: RootState) => state.OpViajesEstatusSecuencia.OpViajesEstatusSecuencia)
  const AllTrips = useSelector((state: RootState) => state.OpViajes.OpViajes)
  const [IDStatus, setIDStatus] = useState(props.Status)
  const [ListaSecuencia, setListaSecuencia] = useState<DTOViajeEstatusSecuencia[]>([])
  const [Secuencia, setSecuencia] = useState(1)

  const enlistaSecuenciaViaje = () => {
    const Lista: DTOViajeEstatusSecuencia[] = mTripStatus
      .filter((row) => row.tipoOperacion === props.TipoOperacion)
      .sort((a, b) => a.secuencia - b.secuencia)
    setListaSecuencia(Lista)
  }

  useEffect(() => {
    const filtraLista: DTOViajeEstatusSecuencia[] = mTripStatus
      .filter((row) => row.estatus === props.Status)
      .sort((a, b) => a.secuencia - b.secuencia)
    setSecuencia(filtraLista[0] ? filtraLista[0].secuencia : 100)
    enlistaSecuenciaViaje()
  }, [])

  useEffect(() => {
    enlistaSecuenciaViaje()
  }, [Secuencia, IDStatus, props])

  const selectedStatus = (e: any) => {
    const idx = parseInt(e.target.value)
    console.log(idx)
    setIDStatus(idx)
    const data: DTOChangeTripStatus = {
      idViaje: props.IDViaje,
      idEstatus: parseInt(e.target.value),
    }
    DSOpStatusSecuence.ChangeTripStatus(data)
      .then((response) => {
        mTripStatus
          .filter((row) => row.tipoOperacion === props.TipoOperacion && row.estatus === IDStatus)
          .sort((a, b) => a.secuencia - b.secuencia)
        let result = AllTrips.filter((a) => {
          if (a.id == props.IDViaje) {
            return a
          }
        })
        let updatedRecord: DTOViajes = {
          cliente: result[0].cliente,
          destino: result[0].destino,
          fAlta: result[0].fAlta,
          hazmat: result[0].hazmat,
          id: result[0].id,
          max: result[0].max,
          noCaja: result[0].noCaja,
          origen: result[0].origen,
          pedimento: result[0].pedimento,
          pickUpNumber: result[0].pickUpNumber,
          refAgenciaAduanal: result[0].refAgenciaAduanal,
          sCliente: result[0].sCliente,
          sDestino: result[0].sDestino,
          sOrigen: result[0].sOrigen,
          sTipoOperacion: result[0].sTipoOperacion,
          sTipoUnidad: result[0].sTipoUnidad,
          status: idx,
          tipoOperacion: result[0].tipoOperacion,
          tipoUnidad: result[0].tipoOperacion,
          usuario: result[0].usuario,
        }
        dispatch(updateOpViajes(updatedRecord))
        if (response.data.secuencia === 100) {
          dispatch(deleteOpViajes(props.IDViaje))
        }
      })
      .catch((e: Error) => {})
  }

  return (
    <div>
      <Form.Control
        as='select'
        onChange={(e) => {
          selectedStatus(e)
        }}
        value={IDStatus}
        className='form-select form-select-sm dialogLabel'
      >
        {ListaSecuencia
          ? ListaSecuencia.filter((row) => row.tipoOperacion === props.TipoOperacion)
              .sort((a, b) => a.secuencia - b.secuencia)
              .map((row) => {
                return (
                  <option key={row.id} value={row.estatus}>
                    {row.sEstatus}
                  </option>
                )
              })
          : null}
      </Form.Control>
    </div>
  )
}
